module.exports = __webpack_public_path__ + "media/images/icons/at-851406d94018ec5f009cbca25095e185.svg";